/**
 * Cart count sync — mirrors the cart-bubble count into the inline
 * (N) element next to the "Cart" text in the header.
 *
 * The cart-bubble count (.cart-bubble__text-count) is updated by
 * Savor's cart-icon.js whenever the cart changes (add to cart,
 * remove line, refresh, etc.). It is hidden via display: none on
 * desktop when display_style is "text", so we can't just CSS-show
 * it — we mirror the count into our own <span data-cart-count>
 * element which sits next to the "Cart" text.
 *
 * We use a MutationObserver on the cart-bubble count node so we
 * catch every update Savor makes, including the case where the
 * count is set to an empty string (when item count >= limit).
 *
 * @example
 *   <span data-cart-count>3</span>  →  rendered as "Cart (3)"
 *   when cart has 3 items.
 */
(function () {
  function syncCount(rawText) {
    const count = parseInt(rawText, 10);
    const display = !isNaN(count) && count > 0 ? String(count) : '';

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      // Set textContent (don't remove the element). The base.css
      // :empty rule hides the element when content is "", so it
      // looks like "Cart" without the (N) when the cart is empty,
      // and "Cart (1)" / "Cart (3)" / etc. when there are items.
      if (el.textContent !== display) {
        el.textContent = display;
      }
    });
  }

  function attach() {
    const source = document.querySelector('.cart-bubble__text-count');
    if (!source) return;

    // Initial sync — covers the case where the page was loaded with
    // a non-empty cart (Liquid rendered <span data-cart-count>3</span>).
    syncCount(source.textContent);

    // Watch for text changes — Savor updates textContent on every
    // cart-line event, so this fires for add-to-cart, remove line,
    // quantity updates, etc.
    const observer = new MutationObserver(() => {
      syncCount(source.textContent);
    });
    observer.observe(source, {
      characterData: true,
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
